import { useSearchModels } from '#pplx/frontend/ask-models/hooks/useSearchModels.js';
import { getSearchModeForSearchModel, SearchMode, } from '#pplx/frontend/ask-models/types/search-modes.js';
import { useCallback } from 'react';
/**
 * @deprecated Use `useSearchModels` directly and call `getModelMode` from it.
 */
export const useSearchModeForSearchModel = () => {
    const { getModelMode } = useSearchModels({
        reason: 'use_search_mode_for_search_model',
    });
    return useCallback((model, defaultMode = SearchMode.SEARCH) => {
        if (!model) {
            return defaultMode;
        }
        return getModelMode(model) ?? getSearchModeForSearchModel(model, defaultMode);
    }, [getModelMode]);
};
//# sourceMappingURL=useSearchModeForSearchModel.js.map